<div class="card">
  <div class="card-body">
    <div class="row text-left mt-3">
      <div class="col-sm-12">
        <div class="d-flex justify-content-between mb-0">
          <h1 class="text-bold-400" style="color: #4e7977">Exportação de Relatórios do Sistema</h1>
        </div>
      </div>
      <div class="col-12">
        <p class="mb-2 mt-2" style="font-size: 20px">
          Exporte relatórios da situação da base atual. Selecione um modelo padrão ou modifique os campos por arquivo selecionado.
        </p>
      </div>
    </div>

    <div class="col-12">
      <ngb-tabset type="tabs" class="custom-tabs">
        <ngb-tab title="SPREV">
          <ng-template ngbTabContent>
            <!-- Cabeçalho geral removido: cada seção abaixo possui seu próprio título, switch e texto explicativo -->

              <!-- Seção 1: Servidores Ativos -->
              <div class="card mb-4">
                <div class="card-body">
                  <div class="d-flex justify-content-between align-items-center mb-2">
                    <h5 class="mb-0 section-title">Servidores Ativos</h5>
                    <div class="d-flex align-items-center">
                      <span class="switch-label">INCLUIR ARQUIVO</span>
                      <ui-switch
                        [ngModel]="exportarAtivos"
                        (ngModelChange)="exportarAtivos = $event"
                        class="switchery"
                        placement="top"
                        ngbTooltip="Incluir arquivo de Servidores Ativos"
                      ></ui-switch>
                    </div>
                  </div>
                  <div class="row mb-3" *ngIf="exportarAtivos">
                    <div class="col-md-8">
                      <p class="mb-0" style="font-size: 16px">
                        Marque abaixo as opções que deseja incluir na exportação do relatório. Por padrão, o relatório inclui todos os arquivos e dados no modelo SPREV.
                      </p>
                    </div>
                    <div class="col-md-4">
                      <div class="d-flex justify-content-end">
                        <button 
                          type="button" 
                          class="btn btn-outline-danger btn-desmarcar me-2"
                          (click)="desmarcarTodos('sprev-ativos')"
                          [disabled]="!exportarAtivos">
                          <i class="fa fa-square-o me-1"></i> Desmarcar Todos
                        </button>
                        <button 
                          type="button" 
                          class="btn btn-outline-primary"
                          (click)="selecionarTudo('sprev-ativos')"
                          [disabled]="!exportarAtivos">
                          <i class="fa fa-check-square me-1"></i> Marcar Todos
                        </button>
                      </div>
                    </div>
                  </div>
                  <!-- Tabela de Campos -->
                  <div class="table-responsive" *ngIf="exportarAtivos">
                    <table class="table table-striped">
                      <thead>
                        <tr>
                          <th>Descrição do Dado</th>
                          <th>Exemplo</th>
                          <th>Incluir Dado?</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let campo of camposSPREVAtivos">
                          <td>{{ campo.label }}</td>
                          <td>{{ campo.exemplo }}</td>
                          <td>
                            <div class="form-check">
                              <input 
                                class="form-check-input" 
                                type="checkbox" 
                                [id]="'sprev-ativo-' + campo.id" 
                                [(ngModel)]="campo.checked"
                                [disabled]="!exportarAtivos">
                              <label class="form-check-label" [for]="'sprev-ativo-' + campo.id">
                                &nbsp;
                              </label>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <!-- Seção 2: Servidores Inativos -->
              <div class="card mb-4">
                <div class="card-body">
                  <div class="d-flex justify-content-between align-items-center mb-2">
                    <h5 class="mb-0 section-title">Servidores Inativos</h5>
                    <div class="d-flex align-items-center">
                      <span class="switch-label">INCLUIR ARQUIVO</span>
                      <ui-switch
                        [ngModel]="exportarInativos"
                        (ngModelChange)="exportarInativos = $event"
                        class="switchery"
                        placement="top"
                        ngbTooltip="Incluir arquivo de Servidores Inativos"
                      ></ui-switch>
                    </div>
                  </div>
                  <div class="row mb-3" *ngIf="exportarInativos">
                    <div class="col-md-8">
                      <p class="mb-0" style="font-size: 16px">
                        Marque abaixo as opções que deseja incluir na exportação do relatório. Por padrão, o relatório inclui todos os arquivos e dados no modelo SPREV.
                      </p>
                    </div>
                    <div class="col-md-4">
                      <div class="d-flex justify-content-end">
                        <button 
                          type="button" 
                          class="btn btn-outline-danger btn-desmarcar me-2"
                          (click)="desmarcarTodos('sprev-inativos')"
                          [disabled]="!exportarInativos">
                          <i class="fa fa-square-o me-1"></i> Desmarcar Todos
                        </button>
                        <button 
                          type="button" 
                          class="btn btn-outline-primary"
                          (click)="selecionarTudo('sprev-inativos')"
                          [disabled]="!exportarInativos">
                          <i class="fa fa-check-square me-1"></i> Marcar Todos
                        </button>
                      </div>
                    </div>
                  </div>
                  <!-- Tabela de Campos -->
                  <div class="table-responsive" *ngIf="exportarInativos">
                    <table class="table table-striped">
                      <thead>
                        <tr>
                          <th>Descrição do Dado</th>
                          <th>Exemplo</th>
                          <th>Incluir Dado?</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let campo of camposSPREVInativos">
                          <td>{{ campo.label }}</td>
                          <td>{{ campo.exemplo }}</td>
                          <td>
                            <div class="form-check">
                              <input 
                                class="form-check-input" 
                                type="checkbox" 
                                [id]="'sprev-inativo-' + campo.id" 
                                [(ngModel)]="campo.checked"
                                [disabled]="!exportarInativos">
                              <label class="form-check-label" [for]="'sprev-inativo-' + campo.id">
                                &nbsp;
                              </label>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <!-- Seção 3: Servidores Pensionistas -->
              <div class="card mb-4">
                <div class="card-body">
                  <div class="d-flex justify-content-between align-items-center mb-2">
                    <h5 class="mb-0 section-title">Pensionistas</h5>
                    <div class="d-flex align-items-center">
                      <span class="switch-label">INCLUIR ARQUIVO</span>
                      <ui-switch
                        [ngModel]="exportarPensionistas"
                        (ngModelChange)="exportarPensionistas = $event"
                        class="switchery"
                        placement="top"
                        ngbTooltip="Incluir arquivo de Pensionistas"
                      ></ui-switch>
                    </div>
                  </div>
                  <div class="row mb-3" *ngIf="exportarPensionistas">
                    <div class="col-md-8">
                      <p class="mb-0" style="font-size: 16px">
                        Marque abaixo as opções que deseja incluir na exportação do relatório. Por padrão, o relatório inclui todos os arquivos e dados no modelo SPREV.
                      </p>
                    </div>
                    <div class="col-md-4">
                      <div class="d-flex justify-content-end">
                        <button 
                          type="button" 
                          class="btn btn-outline-danger btn-desmarcar me-2"
                          (click)="desmarcarTodos('sprev-pensionistas')"
                          [disabled]="!exportarPensionistas">
                          <i class="fa fa-square-o me-1"></i> Desmarcar Todos
                        </button>
                        <button 
                          type="button" 
                          class="btn btn-outline-primary"
                          (click)="selecionarTudo('sprev-pensionistas')"
                          [disabled]="!exportarPensionistas">
                          <i class="fa fa-check-square me-1"></i> Marcar Todos
                        </button>
                      </div>
                    </div>
                  </div>
                  <!-- Tabela de Campos -->
                  <div class="table-responsive" *ngIf="exportarPensionistas">
                    <table class="table table-striped">
                      <thead>
                        <tr>
                          <th>Descrição do Dado</th>
                          <th>Exemplo</th>
                          <th>Incluir Dado?</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let campo of camposSPREVPensionistas">
                          <td>{{ campo.label }}</td>
                          <td>{{ campo.exemplo }}</td>
                          <td>
                            <div class="form-check">
                              <input 
                                class="form-check-input" 
                                type="checkbox" 
                                [id]="'sprev-pensionista-' + campo.id" 
                                [(ngModel)]="campo.checked"
                                [disabled]="!exportarPensionistas">
                              <label class="form-check-label" [for]="'sprev-pensionista-' + campo.id">
                                &nbsp;
                              </label>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <!-- Botão de Exportação -->
              <div class="d-flex justify-content-end mt-4">
                <button 
                  type="button" 
                  class="btn btn-primary"
                  (click)="abrirModalConfirmacao(confirmarExportacaoModal)">
                  <i class="fa fa-download me-2"></i> Exportar SPREV
                </button>
              </div>
          </ng-template>
        </ngb-tab>

        <ngb-tab title="Servidores">
          <ng-template ngbTabContent>
            <!-- Card -->
            <div class="card mb-4">
              <div class="card-body">
                <h5 class="mb-0 section-title">Relatório de Servidores</h5>
                <div class="row mb-3 mt-3">
                  <div class="col-md-8">
                    <p class="mb-0" style="font-size: 16px">
                      Selecione os campos que deseja incluir na exportação do relatório de servidores.
                    </p>
                  </div>
                  <div class="col-md-4">
                    <div class="d-flex justify-content-end">
                      <button 
                        type="button" 
                        class="btn btn-outline-danger btn-desmarcar me-2"
                        (click)="desmarcarTodos('servidores')">
                        <i class="fa fa-square-o me-1"></i> Desmarcar Todos
                      </button>
                      <button 
                        type="button" 
                        class="btn btn-outline-primary"
                        (click)="selecionarTudo('servidores')">
                        <i class="fa fa-check-square me-1"></i> Marcar Todos
                      </button>
                    </div>
                  </div>
                </div>
                <!-- Tabela de Campos -->
                <div class="table-responsive">
                  <table class="table table-striped">
                    <thead>
                      <tr>
                        <th>Descrição do Dado</th>
                        <th>Exemplo</th>
                        <th>Incluir Dado?</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let campo of camposServidores">
                        <td>{{ campo.label }}</td>
                        <td>{{ campo.exemplo }}</td>
                        <td>
                          <div class="form-check">
                            <input 
                              class="form-check-input" 
                              type="checkbox" 
                              [id]="'servidor-' + campo.id" 
                              [(ngModel)]="campo.checked">
                            <label class="form-check-label" [for]="'servidor-' + campo.id">
                              &nbsp;
                            </label>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <!-- Botão de Exportação -->
            <div class="d-flex justify-content-end mt-4">
              <button 
                type="button" 
                class="btn btn-primary"
                (click)="exportarRelatorio('servidores')">
                <i class="fa fa-download me-2"></i> Exportar Servidores
              </button>
            </div>
          </ng-template>
        </ngb-tab>

        <ngb-tab title="Tempo de Serviço Passado">
          <ng-template ngbTabContent>
            <!-- Card -->
            <div class="card mb-4">
              <div class="card-body">
                <h5 class="mb-0 section-title">Relatório de Tempo de Serviço Passado</h5>
                <div class="row mb-3 mt-3">
                  <div class="col-md-8">
                    <p class="mb-0" style="font-size: 16px">
                      Selecione os campos que deseja incluir na exportação do relatório de tempo de serviço passado.
                    </p>
                  </div>
                  <div class="col-md-4">
                    <div class="d-flex justify-content-end">
                      <button 
                        type="button" 
                        class="btn btn-outline-danger btn-desmarcar me-2"
                        (click)="desmarcarTodos('tempo-servico')">
                        <i class="fa fa-square-o me-1"></i> Desmarcar Todos
                      </button>
                      <button 
                        type="button" 
                        class="btn btn-outline-primary"
                        (click)="selecionarTudo('tempo-servico')">
                        <i class="fa fa-check-square me-1"></i> Marcar Todos
                      </button>
                    </div>
                  </div>
                </div>
                <!-- Tabela de Campos -->
                <div class="table-responsive">
                  <table class="table table-striped">
                    <thead>
                      <tr>
                        <th>Descrição do Dado</th>
                        <th>Exemplo</th>
                        <th>Incluir Dado?</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let campo of camposTempoServico">
                        <td>{{ campo.label }}</td>
                        <td>{{ campo.exemplo }}</td>
                        <td>
                          <div class="form-check">
                            <input 
                              class="form-check-input" 
                              type="checkbox" 
                              [id]="'tempo-' + campo.id" 
                              [(ngModel)]="campo.checked">
                            <label class="form-check-label" [for]="'tempo-' + campo.id">
                              &nbsp;
                            </label>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <!-- Botão de Exportação -->
            <div class="d-flex justify-content-end mt-4">
              <button 
                type="button" 
                class="btn btn-primary"
                (click)="exportarRelatorio('tempo-servico')">
                <i class="fa fa-download me-2"></i> Exportar Tempo de Serviço
              </button>
            </div>
          </ng-template>
        </ngb-tab>

        <ngb-tab title="Atendimentos">
          <ng-template ngbTabContent>
            <!-- Card -->
            <div class="card mb-4">
              <div class="card-body">
                <h5 class="mb-0 section-title">Relatório de Atendimentos</h5>
                <div class="row mb-3 mt-3">
                  <div class="col-md-8">
                    <p class="mb-0" style="font-size: 16px">
                      Selecione os campos que deseja incluir na exportação do relatório de atendimentos.
                    </p>
                  </div>
                  <div class="col-md-4">
                    <div class="d-flex justify-content-end">
                      <button 
                        type="button" 
                        class="btn btn-outline-danger btn-desmarcar me-2"
                        (click)="desmarcarTodos('atendimentos')">
                        <i class="fa fa-square-o me-1"></i> Desmarcar Todos
                      </button>
                      <button 
                        type="button" 
                        class="btn btn-outline-primary"
                        (click)="selecionarTudo('atendimentos')">
                        <i class="fa fa-check-square me-1"></i> Marcar Todos
                      </button>
                    </div>
                  </div>
                </div>
                <!-- Tabela de Campos -->
                <div class="table-responsive">
                  <table class="table table-striped">
                    <thead>
                      <tr>
                        <th>Descrição do Dado</th>
                        <th>Exemplo</th>
                        <th>Incluir Dado?</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let campo of camposAtendimentos">
                        <td>{{ campo.label }}</td>
                        <td>{{ campo.exemplo }}</td>
                        <td>
                          <div class="form-check">
                            <input 
                              class="form-check-input" 
                              type="checkbox" 
                              [id]="'atendimento-' + campo.id" 
                              [(ngModel)]="campo.checked">
                            <label class="form-check-label" [for]="'atendimento-' + campo.id">
                              &nbsp;
                            </label>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <!-- Botão de Exportação -->
            <div class="d-flex justify-content-end mt-4">
              <button 
                type="button" 
                class="btn btn-primary"
                (click)="exportarRelatorio('atendimentos')">
                <i class="fa fa-download me-2"></i> Exportar Atendimentos
              </button>
            </div>
          </ng-template>
        </ngb-tab>

        <ngb-tab title="Pendências">
          <ng-template ngbTabContent>
            <!-- Card -->
            <div class="card mb-4">
              <div class="card-body">
                <h5 class="mb-0 section-title">Relatório de Pendências</h5>
                <div class="row mb-3 mt-3">
                  <div class="col-md-8">
                    <p class="mb-0" style="font-size: 16px">
                      Selecione os campos que deseja incluir na exportação do relatório de pendências.
                    </p>
                  </div>
                  <div class="col-md-4">
                    <div class="d-flex justify-content-end">
                      <button 
                        type="button" 
                        class="btn btn-outline-danger btn-desmarcar me-2"
                        (click)="desmarcarTodos('pendencias')">
                        <i class="fa fa-square-o me-1"></i> Desmarcar Todos
                      </button>
                      <button 
                        type="button" 
                        class="btn btn-outline-primary"
                        (click)="selecionarTudo('pendencias')">
                        <i class="fa fa-check-square me-1"></i> Marcar Todos
                      </button>
                    </div>
                  </div>
                </div>
                <!-- Tabela de Campos -->
                <div class="table-responsive">
                  <table class="table table-striped">
                    <thead>
                      <tr>
                        <th>Descrição do Dado</th>
                        <th>Exemplo</th>
                        <th>Incluir Dado?</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let campo of camposPendencias">
                        <td>{{ campo.label }}</td>
                        <td>{{ campo.exemplo }}</td>
                        <td>
                          <div class="form-check">
                            <input 
                              class="form-check-input" 
                              type="checkbox" 
                              [id]="'pendencias-' + campo.id" 
                              [(ngModel)]="campo.checked">
                            <label class="form-check-label" [for]="'pendencias-' + campo.id">
                              &nbsp;
                            </label>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <!-- Botão de Exportação -->
            <div class="d-flex justify-content-end mt-4">
              <button 
                type="button" 
                class="btn btn-primary"
                (click)="exportarRelatorio('pendencias')">
                <i class="fa fa-download me-2"></i> Exportar Pendências
              </button>
            </div>
          </ng-template>
        </ngb-tab>

        <ngb-tab title="Servidores Ativos">
          <ng-template ngbTabContent>
            <!-- Card -->
            <div class="card mb-4">
              <div class="card-body">
                <h5 class="mb-0 section-title">Relatório de Servidores Ativos</h5>
                <div class="row mb-3 mt-3">
                  <div class="col-md-8">
                    <p class="mb-0" style="font-size: 16px">
                      Selecione os campos que deseja incluir na exportação do relatório de servidores ativos.
                    </p>
                  </div>
                  <div class="col-md-4">
                    <div class="d-flex justify-content-end">
                      <button 
                        type="button" 
                        class="btn btn-outline-danger btn-desmarcar me-2"
                        (click)="desmarcarTodos('servidores-ativos')">
                        <i class="fa fa-square-o me-1"></i> Desmarcar Todos
                      </button>
                      <button 
                        type="button" 
                        class="btn btn-outline-primary"
                        (click)="selecionarTudo('servidores-ativos')">
                        <i class="fa fa-check-square me-1"></i> Marcar Todos
                      </button>
                    </div>
                  </div>
                </div>
                <!-- Tabela de Campos -->
                <div class="table-responsive">
                  <table class="table table-striped">
                    <thead>
                      <tr>
                        <th>Descrição do Dado</th>
                        <th>Incluir Dado?</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let campo of camposServidoresAtivos">
                        <td>{{ campo.label }}</td>
                        <td>
                          <div class="form-check">
                            <input 
                              class="form-check-input" 
                              type="checkbox" 
                              [id]="'servidor-ativo-' + campo.id" 
                              [(ngModel)]="campo.checked">
                            <label class="form-check-label" [for]="'servidor-ativo-' + campo.id">
                              &nbsp;
                            </label>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <!-- Botão de Exportação -->
            <div class="d-flex justify-content-end mt-4">
              <button 
                type="button" 
                class="btn btn-primary"
                (click)="exportarRelatorio('servidores-ativos')">
                <i class="fa fa-download me-2"></i> Exportar Servidores Ativos
              </button>
            </div>
          </ng-template>
        </ngb-tab>

        <ngb-tab title="Servidores Inativos">
          <ng-template ngbTabContent>
            <!-- Card -->
            <div class="card mb-4">
              <div class="card-body">
                <h5 class="mb-0 section-title">Relatório de Servidores Inativos</h5>
                <div class="row mb-3 mt-3">
                  <div class="col-md-8">
                    <p class="mb-0" style="font-size: 16px">
                      Selecione os campos que deseja incluir na exportação do relatório de servidores inativos.
                    </p>
                  </div>
                  <div class="col-md-4">
                    <div class="d-flex justify-content-end">
                      <button 
                        type="button" 
                        class="btn btn-outline-danger btn-desmarcar me-2"
                        (click)="desmarcarTodos('servidores-inativos')">
                        <i class="fa fa-square-o me-1"></i> Desmarcar Todos
                      </button>
                      <button 
                        type="button" 
                        class="btn btn-outline-primary"
                        (click)="selecionarTudo('servidores-inativos')">
                        <i class="fa fa-check-square me-1"></i> Marcar Todos
                      </button>
                    </div>
                  </div>
                </div>
                <!-- Tabela de Campos -->
                <div class="table-responsive">
                  <table class="table table-striped">
                    <thead>
                      <tr>
                        <th>Descrição do Dado</th>
                        <th>Incluir Dado?</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let campo of camposServidoresInativos">
                        <td>{{ campo.label }}</td>
                        <td>
                          <div class="form-check">
                            <input 
                              class="form-check-input" 
                              type="checkbox" 
                              [id]="'servidor-inativo-' + campo.id" 
                              [(ngModel)]="campo.checked">
                            <label class="form-check-label" [for]="'servidor-inativo-' + campo.id">
                              &nbsp;
                            </label>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <!-- Botão de Exportação -->
            <div class="d-flex justify-content-end mt-4">
              <button 
                type="button" 
                class="btn btn-primary"
                (click)="exportarRelatorio('servidores-inativos')">
                <i class="fa fa-download me-2"></i> Exportar Servidores Inativos
              </button>
            </div>
          </ng-template>
        </ngb-tab>

        <ngb-tab title="Servidores Pensionistas">
          <ng-template ngbTabContent>
            <!-- Card -->
            <div class="card mb-4">
              <div class="card-body">
                <h5 class="mb-0 section-title">Relatório de Servidores Pensionistas</h5>
                <div class="row mb-3 mt-3">
                  <div class="col-md-8">
                    <p class="mb-0" style="font-size: 16px">
                      Selecione os campos que deseja incluir na exportação do relatório de servidores pensionistas.
                    </p>
                  </div>
                  <div class="col-md-4">
                    <div class="d-flex justify-content-end">
                      <button 
                        type="button" 
                        class="btn btn-outline-danger btn-desmarcar me-2"
                        (click)="desmarcarTodos('servidores-pensionistas')">
                        <i class="fa fa-square-o me-1"></i> Desmarcar Todos
                      </button>
                      <button 
                        type="button" 
                        class="btn btn-outline-primary"
                        (click)="selecionarTudo('servidores-pensionistas')">
                        <i class="fa fa-check-square me-1"></i> Marcar Todos
                      </button>
                    </div>
                  </div>
                </div>
                <!-- Tabela de Campos -->
                <div class="table-responsive">
                  <table class="table table-striped">
                    <thead>
                      <tr>
                        <th>Descrição do Dado</th>
                        <th>Incluir Dado?</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let campo of camposServidoresPensionistas">
                        <td>{{ campo.label }}</td>
                        <td>
                          <div class="form-check">
                            <input 
                              class="form-check-input" 
                              type="checkbox" 
                              [id]="'servidor-pensionista-' + campo.id" 
                              [(ngModel)]="campo.checked">
                            <label class="form-check-label" [for]="'servidor-pensionista-' + campo.id">
                              &nbsp;
                            </label>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <!-- Botão de Exportação -->
            <div class="d-flex justify-content-end mt-4">
              <button 
                type="button" 
                class="btn btn-primary"
                (click)="exportarRelatorio('servidores-pensionistas')">
                <i class="fa fa-download me-2"></i> Exportar Servidores Pensionistas
              </button>
            </div>
          </ng-template>
        </ngb-tab>

      </ngb-tabset>
    </div>
  </div>
</div>

<!-- Modal de Confirmação de Exportação -->
<ng-template #confirmarExportacaoModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Confirmar Exportação</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p class="mb-3 modal-text">Deseja exportar os seguintes arquivos do sistema:</p>
    <ul class="list-unstyled modal-file-list">
      <li *ngIf="exportarAtivos" class="mb-2">
        servidores_ativos_sprev.xls
      </li>
      <li *ngIf="exportarInativos" class="mb-2">
        servidores_inativos_sprev.xls
      </li>
      <li *ngIf="exportarPensionistas" class="mb-2">
        servidores_pensionistas_sprev.xls
      </li>
    </ul>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-primary" (click)="modal.dismiss('Cancel click')">
      Voltar
    </button>
    <button type="button" class="btn btn-primary" (click)="confirmarExportacao(modal)">
      <i class="fa fa-download me-2"></i>
      Exportar
    </button>
  </div>
</ng-template>

<ngx-spinner></ngx-spinner>